<div class="component-container" [class.off]="awayCtrl === 'off' && homeCtrl === 'off'"
     [class.odm-home]="teamSide === 'home'"
     [class.odm-away]="teamSide === 'away'">
  <div class="component-wrap">
    <div class="player-list">
      <h3>Lineup:</h3>
      <div class="player" *ngFor="let line of lineup; let idx = index">
        <div class="order">{{ idx +1 }}.</div>
        <div class="name" [style.fontSize.px]="getFontSize(line.players[0])">{{ line.players[0].name.toUpperCase() }}</div>
        <div class="position">{{ utilService.positionToString(line.players[0].position) }}</div>
      </div>
      <div class="player" *ngIf="pitcher?.guid && pitcher.guid != '-2'">
        <div class="order">
          <ng-container *ngIf="pitcher?.position === 1">
            P:
          </ng-container>
          <ng-container *ngIf="pitcher?.position !== 1">
            F:
          </ng-container>
        </div>
        <div class="name">{{ pitcher?.name.toUpperCase() }}</div>
        <div class="position" *ngIf="pitcher?.position !== 1 && pitcher?.position">{{ utilService.positionToString(pitcher.position) }}</div>
      </div>
    </div>
  </div>
  <div class="team-section"
       [style.background-color]="teamBrg">
    <div class="logo">
      <ng-container *ngIf="!utilService.hideTeamLogos(broadcast); else teamCode">
        <img *ngIf="homeCtrl === 'on'; else awayLogo" src="{{ broadcast.config.homeConfig.logoUrl }}">
        <ng-template #awayLogo>
          <img *ngIf="awayCtrl === 'on'" src="{{ broadcast.config.awayConfig.logoUrl }}">
        </ng-template>
      </ng-container>
      <ng-template #teamCode>
        <span class="team-code">{{ teamSide === 'home' ? broadcast.config.homeConfig.shortName : (teamSide === 'away' ? broadcast.config.awayConfig.shortName : '') }}</span>
      </ng-template>
    </div>
    <div class="name">
      {{ teamSide === 'home' ? broadcast.config.homeConfig.fullName : (teamSide === 'away' ? broadcast.config.awayConfig.fullName : '') }}
    </div>
  </div>
</div>
